import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const ImageUpload = ({ workflowId, selectedImages, setSelectedImages }) => {
  const [buttonValue, setButtonValue] = useState(false);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [currentIndex, setCurrentIndex] = useState(0);
  var { apiBaseUrl } = configData.config;
  const { token } = userData;

  const [progress, setProgress] = useState(0);

  const handleFileChange = (event) => {
    const updatedFiles = event.target.files;
    setProgress(0);

    for (let a = 0; a < updatedFiles.length; a++) {
      uploadFile(updatedFiles[a]);
    }
  };

  const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post(
        `${apiBaseUrl}/api/uno/upload/media/${workflowId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progressPercent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            setProgress(progressPercent);
          },
        }
      );
      setSelectedImages((prevSelectedImage) => [...prevSelectedImage, data.url]);
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const removeSelectedImage = (file) => {
    const updatedImages = selectedImages.filter((selectedFile) => selectedFile !== file);
    setSelectedImages(updatedImages);
  };

  const onImageSubmit = () => {
    // Handle the logic for submitting the selected images
    console.log("Submitting images:", selectedImages);
  };


  useEffect(() => {

    console.log("workflowId workflowId image ")
    console.log(workflowId)
  }, [workflowId])

  return (
    <div className="card mt-3" style={{ height: "auto" }}>
      {/* <div className="card-header">
        <div className="row">
          <div className="col-md-6">
            <h4 className="card-title mb-3" style={{ color: "#000", fontWeight: "500" }}>
              Upload Images
            </h4>
          </div>
          <div className="col-sm-6 text-sm-right"></div>
        </div>
      </div> */}

      <div className="card-body d-block">
        <div>
          <label className="custom-file-upload">
            <i className="fas fa-cloud-upload-alt"></i> Image
            <input type="file" accept="image/*" onChange={handleFileChange} multiple style={{ opacity: '0' }} />
          </label>
          {/* <input type="file" accept="image/*" onChange={handleFileChange} multiple /> */}
          <div className="uploadedimgshow uplcont">
            {selectedImages.map((file, index) => (
              <span key={index}>
                <img src={file} alt="" />
                <i className="fa fa-times" onClick={() => removeSelectedImage(file)}></i>
              </span>
            ))}
          </div>
        </div>


        {/* <div className="text-center mt-3">
          <button className="btn btn-sm btn-success" disabled >
            <i className="fa fa-upload"></i> Upload Images
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ImageUpload;
